<template>
    <div v-if="image && wrapperClass" :class="wrapperClass" ref="imageLayer">
        <img :src="image.placeholder" :data-src="image.src" :class="image.class" alt="" :data-width="image.width"/>
    </div>
</template>

<script src="./image-layer.js"></script>
